import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { useAccount } from '../contexts/AccountContext';
import { firestore } from '../services/firebase';
import type { Procurement } from '../types/procurement';

export const useProcurements = () => {
  const { account } = useAccount();
  const [procurements, setProcurements] = useState<Procurement[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!account?.clientId) {
      setProcurements([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    const q = query(
      collection(firestore, 'procurements'),
      where('clientId', '==', account.clientId)
    );

    const unsubscribe = onSnapshot(
      q,
      (snapshot) => {
        const docs = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        })) as Procurement[];
        setProcurements(docs);
        setLoading(false);
      },
      (err) => {
        setError(err);
        setLoading(false);
      }
    );

    return () => unsubscribe();
  }, [account?.clientId]);

  return { procurements, loading, error };
};
